<template>
  <div>
    <template v-if="accountData">
      <v-card
        class="card pa-4"
        color="gray10"
        flat
        v-if="accountData.status.title === 'REJECTED'"
      >
        <div class="d-flex title">
          <v-icon>$editList</v-icon>
          <h2 class="font-Light-16 ms-2 ">
            {{
              $t(
                "corporateAccount.manage.create.step1.editLegalAccountDocuments"
              )
            }}
          </h2>
        </div>
        <p class="gray3--text font-Regular-16 py-4">
          {{
            $t("corporateAccount.manage.create.step1.documentsNeedCorrection")
          }}
        </p>
        <div class="gray13 pa-4 rounded-lg" style="color: #F23030">
          {{ accountData.reject_reason.subject }} :
          {{ accountData.reject_reason.description }}
        </div>
        <div class="d-flex items-center justify-center mt-4 ">
          <v-btn
            x-large
            color="primary"
            class="mx-auto px-16"
            @click="$emit('nextStep', 2, $route.query.CA_ID)"
          >
            {{ $t("corporateAccount.manage.create.step1.submitAndContinue") }}
          </v-btn>
        </div>
      </v-card>
    </template>
    <v-card class="card pa-4" color="gray10" flat v-else>
      <div class="d-flex title">
        <v-icon>$editList</v-icon>
        <h2 class="font-Light-16 ms-2 ">
          {{ $t("corporateAccount.manage.createLegalAccount") }}
        </h2>
      </div>
      <p class="gray3--text font-Regular-16 py-4">
        {{
          $t("corporateAccount.manage.create.step1.legalAccountInstructions")
        }}
      </p>

      <v-row class="py-5">
        <v-col cols="12" md="6">
          <v-text-field
            hide-details
            filled
            class="custom-form-control"
            v-model="payload.name"
            :placeholder="
              $t('corporateAccount.manage.create.step1.companyName')
            "
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            hide-details
            filled
            class="custom-form-control"
            v-model="payload.signatory_members_count"
            :placeholder="
              $t('corporateAccount.manage.create.step1.companyMembersCount')
            "
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <div class="d-flex justify-space-between  gray-border py-2 px-4">
            <div class="d-flex align-center">
              <v-icon>$editList</v-icon>
              <h2 class="font-Light-16  ms-2 ">
                {{
                  $t(
                    "corporateAccount.manage.create.step1.requiredDocumentsFile"
                  )
                }}
              </h2>
            </div>
            <v-btn
              :href="attachFile"
              target="_blank"
              depressed
              class="gray7 primary--text"
              >{{ $t("shared.download") }}</v-btn
            >
          </div>
        </v-col>
      </v-row>
      <div class="d-flex items-center justify-center mt-4 ">
        <v-btn
          x-large
          color="primary"
          class="mx-auto  px-16"
          @click="nextStep"
          :loading="isLoading"
          :disabled="!payload.name || !payload.signatory_members_count"
        >
          {{ $t("corporateAccount.manage.create.step1.submitAndContinue") }}
        </v-btn>
      </div>
    </v-card>

    <v-card class="card  mt-4 " color="gray10" flat>
      <div class="d-flex title pa-4">
        <v-icon>$adjust</v-icon>
        <h2 class="font-Light-16 ms-2 ">
          {{
            $t(
              "corporateAccount.manage.create.step1.viewAllCompanyMembersAccess"
            )
          }}
        </h2>
      </div>
      <ul class="px-0">
        <li
          v-for="(item, index) in accessList"
          :key="index"
          class="access-item d-flex justify-space-between align-center pa-4"
        >
          <span>{{ item.label }}</span>
          <span
            :class="{
              'info-status': item.value === 'requireAllSigns',
              'success-status': item.value === 'active'
            }"
          >
            {{ item.valueLabel }}
          </span>
        </li>
      </ul>
    </v-card>
  </div>
</template>
<script lang="ts">
import legalService from "@/services/modules/legalService";
import { mapGetters } from "vuex";
import * as types from "@/store/types";
export default {
  data() {
    return {
      accountData: null,
      attachFile: "",
      payload: {
        name: "",
        signatory_members_count: ""
      },
      isLoading: false,
      accessList: [
        {
          label: this.$t("corporateAccount.manage.create.step1.deposit"),
          value: "active",
          valueLabel: this.$t("corporateAccount.manage.create.step1.active")
        },
        {
          label: this.$t("corporateAccount.manage.create.step1.withdrawal"),
          value: "requireAllSigns",
          valueLabel: this.$t(
            "corporateAccount.manage.create.step1.requiresAllMembersApproval"
          )
        },
        {
          label: this.$t("corporateAccount.manage.create.step1.spotTrades"),
          value: "active",
          valueLabel: this.$t("corporateAccount.manage.create.step1.active")
        },
        {
          label: this.$t("corporateAccount.manage.create.step1.OTCTrades"),
          value: "active",
          valueLabel: this.$t("corporateAccount.manage.create.step1.active")
        },
        {
          label: this.$t("corporateAccount.manage.create.step1.staking"),
          value: "active",
          valueLabel: this.$t("corporateAccount.manage.create.step1.active")
        },
        {
          label: this.$t(
            "corporateAccount.manage.create.step1.transferToMarketWallet"
          ),
          value: "active",
          valueLabel: this.$t("corporateAccount.manage.create.step1.active")
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      getAccountById: types.corporate.getters.GET_ACCOUNT_BY_UUID
    })
  },
  mounted() {
    this.getFileAttachment();
    const uuid = this.$route.query.CA_ID;
    if (uuid) {
      const data = this.getAccountById(uuid);
      if (data) {
        this.accountData = data;
      } else {
        this.$router.push("/legal-entity/manage/");
      }
    }
  },
  methods: {
    nextStep() {
      this.isLoading = true;
      legalService
        .createCorporateAccount(this.payload)
        .then(res => {
          const CA_ID = res.data.data.uuid;
          this.$emit("nextStep", 2, CA_ID);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getFileAttachment() {
      legalService.getFileAttachment().then(res => {
        this.attachFile = res.data.data.url;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.access-item {
  border-bottom: 1px solid var(--v-gray7-base);
}
</style>
